import React from "react";
import CountUp from "react-countup";

export default function Counter({ number, title }) {
  return (
    <div className="d-flex justify-content-start"><div className="number"><CountUp duration={10} className="counter" end={number} /></div> <div>{title}</div></div>
  );
}
